import { styled } from '@glitz/react';
import * as style from '../Style';

export default styled.h4({
  fontSize: style.delta,
  fontWeight: 'bold',
  lineHeight: 'normal',
  letterSpacing: '2px',
});
